import { cn } from '@/lib/utils';
import { VERIFIED_LABELS } from '../types';
import type { InstallGuideStatus, Verified } from '../types';

const GUIDE_STYLES: Record<InstallGuideStatus, { label: string; className: string }> = {
  verified: { label: 'Verified', className: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  partly: { label: 'Partly', className: 'bg-amber-50 text-amber-800 border-amber-200' },
  none: { label: 'None', className: 'bg-muted text-muted-foreground border-border' },
};

const pill = 'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium';

export function InstallGuideBadge({ status }: { status: InstallGuideStatus }) {
  const style = GUIDE_STYLES[status];
  return <span className={cn(pill, style.className)}>{style.label}</span>;
}

/** Verified state of one install-guide position. Unverified positions must never look like fact. */
export function VerifiedBadge({ value, testId }: { value: Verified; testId?: string }) {
  const tone = value === 'yes'
    ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
    : value === 'no'
      ? 'bg-red-50 text-red-700 border-red-200'
      : 'bg-amber-50 text-amber-800 border-amber-200';
  return <span data-testid={testId} className={cn(pill, tone)}>{VERIFIED_LABELS[value]}</span>;
}
